const SUFFIX = 'boggle_action_types';
export const END_GAME = `END_GAME_${SUFFIX}`;
export const START_GAME = `START_GAME_${SUFFIX}`;
export const FETCH_BOGGLE_ENDPOINT_SUCCESS = `FETCH_BOGGLE_ENDPOINT_${SUFFIX}`;
export const API_FETCH_START =  `API_FETCH_START_${SUFFIX}`;
export const API_FETCH_ERROR = `API_FETCH_ERROR_${SUFFIX}`;
export const ADD_CORRECT_WORDS = `ADD_CORRECT_WORDS_${SUFFIX}`;
export const ADD_INCORRECT_WORDS = `ADD_INCORRECT_WORDS_${SUFFIX}`;
export const UPDATE_SCORE = `UPDATE_SCORE_${SUFFIX}`;